<template>
  <figure class="inline-video">
    <img :src="poster?.url" @click="playVideo" v-if="poster && !playing && !autoplay" />
    <template v-if="isYoutube">
      <youtube ref="video" :video-id="videoID" :player-vars="{start: 0, autoplay: 1, rel: 0}" v-if="playing" player-width="1920" player-height="1080" />
    </template>
    <template v-else>
      <video ref="video" autoplay muted playsinline loading="lazy" :loop="loop" v-if="playing || autoplay">
        <source :src="video" type="video/mp4" />
      </video>
    </template>
    <inline-svg class="play-button" :src="require('@/assets/icon-play.svg')" v-if="!autoplay && !playing" />
  </figure>
</template>

<script>

export default {
  name: 'InlineVideo',
  props: {
    video: {
      type: String,
      required: true
    },
    poster: {
      type: Object,
      required: false
    },
    autoplay: {
      type: Boolean,
      default: false
    },
    loop: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      playing: false,
      player: null
    }
  },
  computed: {
    isYoutube() {
      return this.video.includes('youtube') || this.video.includes('youtu.be')
    },
    videoID() {
      if (this.isYoutube) {
        return this.video.split('v=')[1]
      }
      return false
    },
  },
  methods: {
    playVideo() {
      this.playing = true
    }
  }
}
</script>
